import styled from "styled-components";
import colours from "styles/colours";
import fonts from "styles/fonts";

export const OldStyledText = styled.p`
  font-size: ${fonts.smallMedium};
  color: ${colours.darkGrey};
  border-radius: 4px 4px 0 0;
  letter-spacing: 0.4px;
  margin: 1.7em 0;
`;

export const StyledText = styled.p`
  font-size: ${fonts.smallMedium};
  color: ${colours.elexonBlack};
  border-radius: 4px 4px 0 0;
  letter-spacing: 0.4px;
`;

export const OldTabButton = styled.button<{
  isActive: boolean;
}>`
  all: unset;
  display: flex;
  justify-content: center;
  flex-grow: 1;
  max-width: 20em;
  cursor: pointer;

  background: ${({ isActive }): string =>
    isActive ? colours.white : "inherit"};
  border: ${({ isActive }): string =>
    isActive ? `1px solid ${colours.highlightGrey}` : "1px solid transparent"};
  border-bottom: 2px solid transparent;

  & ${OldStyledText} {
    border-bottom: ${({ isActive }): string =>
      isActive ? `3px solid ${colours.elexonBlue}` : "0"};
    font-weight: ${({ isActive }): string => (isActive ? "bold" : "normal")};
    letter-spacing: ${({ isActive }): string => (isActive ? "0" : "0.4px")};
  }

  &:hover ${OldStyledText} {
    font-weight: bold;
    letter-spacing: 0;
  }

  &&:focus-visible {
    border: 2px solid ${colours.elexonBlack};
    box-shadow: none;
  }
`;

export const TabButton = styled.button<{
  isActive: boolean;
}>`
  all: unset;
  display: flex;
  justify-content: center;
  cursor: pointer;
  padding: 0 1rem;
  font-weight: 900;

  background: ${({ isActive }): string =>
    isActive ? colours.lightGrey : "inherit"};
  border: 1px solid transparent;
  border-bottom: ${({ isActive }): string =>
    isActive ? `2px solid ${colours.elexonBlack}` : "2px solid transparent"};

  &:hover:not([aria-selected="true"]) ${StyledText} {
      color: ${colours.elexonBlue};
    }
  }

  &&:focus-visible {
    border: 2px solid ${colours.elexonBlack};
    box-shadow: none;
  }
`;

export const OldStyledDiv = styled.div`
  all: unset;
  text-align: center;
  display: flex;
  align-items: center;
  height: 105px;
`;

export const StyledDiv = styled.div`
  all: unset;
  text-align: center;
  display: flex;
  align-items: center;
  height: 48px;
`;
